import instance, { customConfig } from "../../../Utils/Interceptors/Interceptor";

const ObtenerPlanesConservacion = async (values) => {
    try {
        const resultado = await instance.Backend.post("/InformeConservacion/ObtenerPlanesConservacion",values, customConfig);

        return resultado

    } catch (error) {

        console.log(error);

    }

}
export { ObtenerPlanesConservacion };
